import { useState, useCallback, useEffect } from 'react'
import effects from 'app/effects/effects'

export const useInitialNotifcation = () => {
  const [isLoading, setIsLoading] = useState()
  const [error, setError] = useState()
  const [succesValue, setSuccessValue] = useState()
  const fetch = useCallback(() => {
    setIsLoading(true)
    effects.apis
      .getInitialNotification()
      .then((value) => {
        setSuccessValue(value)
        setError(null)
      })
      .catch((err) => setError(err))
      .finally(() => setIsLoading(false))
  }, [])

  useEffect(() => {
    fetch()
  }, [fetch])

  return { isLoading, succesValue, fetch, error }
}
